import { Injectable } from '@angular/core';
import { ExceptionResolution, OrderItem } from '@usf/ngrx-order';
import { ExceptionType } from '../constants/order-exception-type.enum';
import { ResolutionTallies } from '../models/resolution-tallies.model';

@Injectable({
  providedIn: 'root',
})
export class ResolutionTallyService {
  /**
   *
   * @param orderExceptions a Map containing ExceptionType as Key and
   * ExceptionResolution array as value
   * @returns a displayable object containing the number of resolved and
   * unresolved exceptions, including special logic for date exceptions
   */
  static tally(
    orderExceptions: Map<ExceptionType, ExceptionResolution[]>,
    orderItems: OrderItem[],
  ): ResolutionTallies {
    const tallies: ResolutionTallies = {
      resolved: 0,
      unresolved: 0,
      totalCasesOrdered: orderItems?.reduce(
        (accumulator, orderItem) =>
          accumulator + (orderItem?.unitsOrdered?.currentValue || 0),
        0,
      ),
      totalCasesReserved: orderItems?.reduce(
        (accumulator, orderItem) =>
          accumulator + (orderItem?.unitsReserved || 0),
        0,
      ),
      totalEachesOrdered: orderItems?.reduce(
        (accumulator, orderItem) =>
          accumulator + (orderItem?.eachesOrdered?.currentValue || 0),
        0,
      ),
      totalEachesReserved: orderItems?.reduce(
        (accumulator, orderItem) =>
          accumulator + (orderItem?.eachesReserved || 0),
        0,
      ),
    };
    Array.from(orderExceptions.keys()).forEach(exceptionType => {
      const resolutions = Array.from(
        orderExceptions.get(exceptionType).values(),
      );
      switch (exceptionType) {
        case ExceptionType.DATE:
          if (resolutions?.length) {
            if (resolutions[0].dateCompleted) {
              tallies.resolved++;
            } else {
              tallies.unresolved++;
            }
          }
          break;
        case undefined:
        case null:
          break;
        default:
          resolutions.forEach(resolution => {
            if (resolution.resolutionOrderItem) {
              tallies.resolved++;
            } else {
              tallies.unresolved++;
            }
          });
          break;
      }
    });
    return tallies;
  }
}
